import { Organisation } from '~organisations/domain';

import logo from './images/logo.png';

const auspostConfig: Organisation = {
  logo: logo,
  additionalOutcomeCaptureFields: {},
  asyncAdditionalOutcomeCaptureFields: {},
  contactAssessmentForms: {},
};

export default auspostConfig;
